import { render } from "./NimbusDataTable.vue?vue&type=template&id=58f10df1"
import script from "./NimbusDataTable.vue?vue&type=script&lang=js"
export * from "./NimbusDataTable.vue?vue&type=script&lang=js"

import "./NimbusDataTable.vue?vue&type=style&index=0&id=58f10df1&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__